<template>
  <div>
    <base-header type="gradient-success" class="pb-6 pt-5 pt-md-6">       
    </base-header>

        <div class="row mx-1">
          <div class="col-md-5">
            <base-input label="Đơn Vị" v-model="editjob.orgName" disabled></base-input>
          </div>
          <div class="col-md-5">
            <base-input label="Nhân sự" v-model="editjob.tenant" disabled></base-input>
          </div>
          <div class="col-md-2">
            <base-input class="mb-0" label="Trạng thái" disabled>
                  <select class="form-control" v-model.number="editjob.status">
                    <option value=1>Khởi tạo</option>
                    <option value=2>Xác Nhận</option>
                    <option value=3>Từ Chối</option>
                    <option value=4>Vào Cổng</option>
                    <option value=5>Vào Lễ Tân</option>
                    <option value=6>Vào NOC</option>
                    <option value=7>Ra NOC</option>
                    <option value=8>Ra Lễ Tân</option>
                    <option value=9>Ra Cổng</option>
                  </select>
                </base-input>
          </div>
        </div>
        <hr class="my-0">
        <div class="row mx-1">
          <div class="col-12 col-md-3">
            <h4>Cổng </h4>
            Duyệt Bởi: {{editjob.l1Proctor}}
          </div>
          <div class="col-12 col-md-2">
            <i>Vào</i>
            <base-input addon-left-icon="ni ni-calendar-grid-58">
              <flat-pickr slot-scope="{focus, blur}"
              @on-open="focus"
              @on-close="blur"
              :config="config"
              class="form-control datepicker"
              v-model="editjob.in1Date">
              </flat-pickr>
            </base-input>
          </div>
          <div class="col-12 col-md-2">
            <i>Ra</i>
            <base-input addon-left-icon="ni ni-calendar-grid-58" >
              <flat-pickr slot-scope="{focus, blur}"
                @on-open="focus"
                @on-close="blur"
                :config="config"
                class="form-control datepicker"
                v-model="editjob.out1Date">
              </flat-pickr>
            </base-input>
          </div>
          <div class="col-6 col-md-2">
            <h5>Thẻ Khách</h5>
            <b>{{editjob.l1Id}}</b>
          </div>          
          <div class="col-6 col-md-2">
            <h5>Biển Số Xe</h5>
            <b>{{editjob.vehicleId}}</b>
          </div>
        </div>
        <hr class="my-0">
        <div class="row mx-1">
          <div class="col-12 col-md-3">
            <h4>Lễ Tân</h4>
            Duyệt Bởi: {{editjob.l2Proctor}}
          </div>
          <div class="col-12 col-md-2">
            <i>Vào</i>
            <base-input addon-left-icon="ni ni-calendar-grid-58" >
              <flat-pickr slot-scope="{focus, blur}"
                @on-open="focus"
                @on-close="blur"
                :config="config"
                class="form-control datepicker"
                v-model="editjob.in2Date">
              </flat-pickr>
            </base-input>
          </div>
          <div class="col-12 col-md-2">
            <i>Ra</i>
            <base-input addon-left-icon="ni ni-calendar-grid-58">
              <flat-pickr slot-scope="{focus, blur}"
                @on-open="focus"
                @on-close="blur"
                :config="config"
                class="form-control datepicker"
                v-model="editjob.out2Date">
              </flat-pickr>
            </base-input>
          </div>
          <div class="col-12 col-md">
            <h5>Thẻ Chức Năng</h5>
            <b>{{editjob.l2Id}}</b>
          </div>
        </div>
        <hr class="my-0">
        <div class="row mx-1">
          <div class="col-12 col-md-3">
            <h4>NOC</h4>
            Duyệt Bởi: {{editjob.l3Proctor}}
          </div>
          <div class="col-12 col-md-2">
            <i>Vào</i>
            <base-input addon-left-icon="ni ni-calendar-grid-58">
              <flat-pickr slot-scope="{focus, blur}"
                @on-open="focus"
                @on-close="blur"
                :config="config"
                class="form-control datepicker"
                v-model="editjob.in3Date">
              </flat-pickr>
            </base-input>
          </div>
          <div class="col-12 col-md-2">
            <i>Ra</i>
            <base-input addon-left-icon="ni ni-calendar-grid-58">
              <flat-pickr slot-scope="{focus, blur}"
                @on-open="focus"
                @on-close="blur"
                :config="config"
                class="form-control datepicker"
                v-model="editjob.out3Date">
              </flat-pickr>
            </base-input>
          </div>
          <div class="col-12 col-md">
            <h5>Thẻ Từ</h5>
            <b>{{editjob.l3Id}}</b>
          </div>
        </div>
        <hr class="my-0">
        <div class="row mx-1">
          <div class="col-12 col-md-6">
            <b>Nội Dung</b>
            <textarea class="form-control" id="noidung" rows="2" placeholder="Mục đích công việc" v-model="editjob.content" readonly></textarea>
          </div>
          <div class="col-12 col-md-6">
            <b>Ghi Chú</b>
            <textarea class="form-control" id="notes" rows="2" placeholder="Ghi chú" v-model="editjob.notes" readonly></textarea>
          </div>
        </div>
      <div class="row mx-1 mt-2 float-right">
        <base-button type="info btn-sm" @click="huy">Đóng</base-button>
      </div>
  </div>
</template>
<script>
export default {
    components: {

    },
  data() {
    return {

    editjob: {},
    config: {
      enableTime:"true",
      dateFormat:"d-m-Y H:i",
      time_24hr: true,
      clickOpens: false

    }
    }
  },
  methods: {
    async getjob() {
      let res = await this.$http.get('/jobs/', {params:{"id":this.$route.params.jobid}})
      this.editjob = res.data[0]
    },
    huy() {
      this.$router.go(-1)
    },

  },
  mounted() {
    this.getjob()
  }
  
}
</script>
<style>

</style>